<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/settings_sub.jpg" />
      <h1 class="">会員サイト利⽤登録本解除</h1>
    </div>
    <div id="MailSetting" class="detail-cart my-5 border box-p-20">
      <h2 class="mb-5">
        以下の本解除ボタンを押して本解除を実行してください。
      </h2>
    </div>
    <div class="my-5 text-center">
      <button class="btn d-inline-block" v-on:click="putData">会員サイト利用登録を本解除する</button>
    </div>
  </section>
</template>

<script>

import Request from "@/modules/Request";
let request = new Request();
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();

export default {
  data() {
    return {
      info : false,
      achievement : false,
    };
  },
  mounted() {
    this.info = this.$route.params.info;
    this.achievement = this.$route.params.achievement;
    console.log(this.info)
    console.log(this.achievement)
  },
  methods: {
    putData(){
      let postParams = [this.info,this.achievement];
      let requestParams = request.createParams(
        "webMdlMemberInfo",
        "SetUnRegister",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          auth.logout2();
          this.$router.push("/settings/unregister/completeend");
        });
    }
  },
};
</script>
<style>
.detail-cart div.c-radio div.radio_box div {
  min-width: 20%;
  margin-bottom: 10px;
}
.detail-cart div.c-radio div.radio_box label {
  font-weight: bold;
  cursor: pointer;
  font-size: 1.125em;
}
button.btn.d-inline-block {
    width: 330px;
}
</style>
